import productTypesWithBeneficiaries from '@/config/productsTypesWithBeneficiaries'

export const beneficiariesAvailable = (item) => {
  const { product } = Array.isArray(item) ? item[0] : item

  return (
    productTypesWithBeneficiaries.includes(product._typename) ||
    product.shippingWithBeneficiary
  )
}
